/**
 * [Pure] Turns number or string into currency string.
 * @param amount - Number or parseInt viable string to turn into currency string.
 * @param hideDecimal - Boolean to determine whether to display decimals.
 */
export function toCurrency(amount: any, hideDecimal?: boolean): string {
    const negativeSign = amount < 0 ? "-" : "";
    amount = Math.abs(Number(amount) || 0).toFixed(2);
    let i: any = parseInt(amount).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    const top = j ? i.substr(0, j) + "," : '';                                          // 1000000.50 -> 1,
    const body = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",");                     // 1000000.50 -> 000,000
    const decimal = !hideDecimal ? "." + Math.abs(amount - i).toFixed(2).slice(2) : ""; // 1000000.50 -> .50
    return negativeSign + "$" + top + body + decimal;
}
